<div class="col-md-12 main-bg">
    <div id="homeSearchInputView" class="hidden-xs hidden-sm"></div>
    <div id="filtersView" class="filter-bar"></div>
    <div id="upcomingView"></div>
</div>